export const MAPBOX_TOKEN =
  'pk.eyJ1IjoiYWppdGhlZHVjcmliIiwiYSI6ImNrb2R3azI4ZzA2cXUybm8xN3RtcDI4d2cifQ.SdNHtoB14ILWo7JLQVgGGw';
export const LATITUDE = 40.898544852227886;
export const LONGITUDE = -102.1146241873652;
export const MAPBOX_STYLE_LIGHT = 'mapbox://styles/mapbox/streets-v11';
export const MAPBOX_STYLE_DARK = 'mapbox://styles/mapbox/dark-v10';
export const navControlStyle = { right: 10, top: 10 };
